jQuery(document).ready(function ($) {
    $(document).on('change', '.dnJs-ticketShopDesignSelector-design', function (e) {
        var selected = $(this).val();
        var codebox = $('.dnJs-ticketShopDesignSelector-codebox');
        var currentCode = codebox.val();

        currentCode = $(currentCode);

        var firstDiv = $(currentCode[0]);

        if (selected.replace(/\s/g, "") == "") {
            firstDiv.attr('data-design', null);
        } else {
            firstDiv.attr('data-design', selected);
        }

        currentCode[0] = firstDiv[0];

        var nextCode = '';

        currentCode.each(function (k, val) {
            if (typeof val.outerHTML !== "undefined") {
                nextCode += val.outerHTML;
            }
        });

        codebox.val(nextCode);
    });

    $(document).on('change', '.dnJs-ticketShopDesignSelector-language', function (e) {
        var selected = $(this).val();
        var codebox = $('.dnJs-ticketShopDesignSelector-codebox');
        var currentCode = codebox.val();

        currentCode = $(currentCode);

        var firstDiv = $(currentCode[0]);

        if (selected === "de") {
            firstDiv.attr('data-lang', null);
        } else {
            firstDiv.attr('data-lang', selected);
        }

        currentCode[0] = firstDiv[0];

        var nextCode = '';

        currentCode.each(function (k, val) {
            if (typeof val.outerHTML !== "undefined") {
                nextCode += val.outerHTML;
            }
        });

        codebox.val(nextCode);
    });
});